import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

/**
 * A box. One border, `--r-3`, and no shadow — depth is the sheet's job, not a
 * card's, and the palette's `--shadow` exists for the one thing that floats.
 *
 * It has no variants, and that is the point: `ds/Card.tsx` had `default`,
 * `flat` and `raised`, which meant three answers to "what is a card" and a
 * caller guessing. It is also what a boxed row is made of — `ListRow boxed`
 * becomes a `Row` inside one of these.
 */
export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className = '', children, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={`u-card ${className}`.trim()} {...rest}>
      {children}
    </div>
  )
})
